import { loggerContextManager } from "./smart-context-provider";

export function getUserInteractionTitle(title: string) {
  if (!title) return "";
  return `${title.toLowerCase()}`;
}

export function getDialogOpenedDurationMs(): number {
  const ctx = loggerContextManager.getCurrentDialogContext();
  return ctx?.openedAtMs != null ? Date.now() - ctx.openedAtMs : 0;
}
